import React from 'react';
import { reportError } from '../utils/reportError';
import ReportProblemForm from './ReportProblem/ReportProblemForm';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorContext: null, showReportForm: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        const errorContext = {
            type: 'react-error-boundary',
            message: error?.message || String(error),
            stack: error?.stack || null,
            componentStack: info?.componentStack || null,
        };
        this.setState({ errorContext });
        reportError(error, {
            type: 'react-error-boundary',
            componentStack: info?.componentStack || null,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        background: 'var(--color-bg-primary, #0a0a0a)',
                        color: 'var(--color-text-primary, #fff)',
                        fontFamily: 'sans-serif',
                        gap: '16px',
                    }}>
                        <h2 style={{ margin: 0 }}>Something went wrong</h2>
                        <p style={{ margin: 0, opacity: 0.6, fontSize: 14 }}>
                            The error has been reported. Try reloading.
                        </p>
                        <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                            <button
                                onClick={() => window.location.reload()}
                                style={{
                                    padding: '8px 20px',
                                    background: 'var(--color-accent, #7c3aed)',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    fontSize: 14,
                                }}
                            >
                                Reload
                            </button>
                            <button
                                onClick={() => this.setState({ showReportForm: true })}
                                style={{
                                    padding: '8px 20px',
                                    background: 'transparent',
                                    color: 'var(--color-text-primary, #fff)',
                                    border: '1px solid var(--color-border, #444)',
                                    borderRadius: 6,
                                    cursor: 'pointer',
                                    fontSize: 14,
                                }}
                            >
                                Report this problem
                            </button>
                        </div>
                    </div>
                    {this.state.showReportForm && (
                        // Rendered directly (not via the redux-gated modal): the
                        // crashed tree may have taken the Provider down with it.
                        <ReportProblemForm
                            feature="error-screen"
                            source="error-screen"
                            errorContext={this.state.errorContext}
                            onClose={() => this.setState({ showReportForm: false })}
                        />
                    )}
                </>
            );
        }
        return this.props.children;
    }
}
